import { Component } from '@angular/core';
import { AppState } from '../../../app.state';
import { CustomerService } from '../../services/customer/customer.service';

@Component({
    selector: 'upsc-international-product-disclosure',
    templateUrl: './international-product-disclosure.component.html',
    styleUrls: ['./international-product-disclosure.component.scss'],
})

export class InternationalProductDisclosureComponent {
    public isGBUser = false;
    public isDEUser = false;

    public constructor(private readonly appState: AppState,
                       private readonly customerService: CustomerService,
    ) {
        const customer = this.appState.customer$();
        const userType = this.customerService.getCustomerLanguage(customer);
        if (userType === 'de') {
            this.isDEUser = true;
            this.isGBUser = false;
        } else {
            this.isDEUser = false;
            this.isGBUser = true;
        }
    }
}
